import React, { FC, useCallback, useMemo } from 'react';

import { SchedulingSection } from 'src/components/scheduling2';
import { IScheduledJobConfiguration } from 'src/interfaces/ScheduledJobConfiguration';
import { SETTINGS_SECTION_TYPES } from 'src/types/SettingsSectionTypes';

import { usePropertySettings } from '../context';
import { setScheduling } from '../state';

export const SchedulingSettingsV2: FC = () => {
	const {
		state: { draft: property, errors },
		dispatch
	} = usePropertySettings();

	const propertyError = useMemo(
		() => errors.find((e) => e.sectionId === SETTINGS_SECTION_TYPES.SCHEDULING),
		[errors]
	);

	const onConfigChange = useCallback(
		(config: IScheduledJobConfiguration): void => {
			const scheduledJobConfiguration = config.active ? config : undefined;
			dispatch(setScheduling(scheduledJobConfiguration));
		},
		[dispatch]
	);

	return (
		<SchedulingSection
			initialConfig={property.scheduledJobConfiguration}
			onConfigChange={onConfigChange}
			error={propertyError}
		/>
	);
};
